document.addEventListener('alpine:init', () => {
  function productMedia(data = {}) {
    return {
      ...data,

      isScrolledThumbnails: false,

      isScrolledFullThumbnails: false,

      init() {
        document.addEventListener('produtformselectedvariantchange', (event) => {
          this.render({ variantId: event.detail.selectedVariantId });
        });
      },

      onThumbnailClick(mediaId) {
        this.render({ mediaId });
      },
      
      render({ mediaId, variantId }) {
        var media = this.mediaAll.find((media) => {
          return media.id == mediaId || media.variantIds.includes(variantId);
        });

        if (media) {
          this.$refs.imageContainer.innerHTML = media.html;
          this.selectedMediaId = media.id;
        }
      },

      onScrollThumbnails() {
        this.isScrolledThumbnails = this.$el.scrollTop > 1;
        this.isScrolledFullThumbnails = this.$el.scrollHeight - this.$el.scrollTop - this.$el.clientHeight < 1;
      }
    };
  };

  Alpine.data('productMedia', productMedia);
});
